// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"91d06186","879":"3de125e3","952":"cb0f6d45"}[chunkId] + ".chunk.js";
};